import { truncateNumber } from './math/truncate'

const SUFFIXES = [
	{ value: 1e15, symbol: 'Q' },
	{ value: 1e12, symbol: 'T' },
	{ value: 1e9, symbol: 'B' },
	{ value: 1e6, symbol: 'M' },
	{ value: 1e3, symbol: 'K' }
] as const

export function formatToHumanReadableNumber(num: number | string | bigint, precision = 2): string {
	const processedNum = Number(num)

	if (isNaN(processedNum)) {
		throw new Error(`Invalid number: ${num}`)
	}

	for (const { value, symbol } of SUFFIXES) {
		if (processedNum >= value) {
			const formatted = truncateNumber(processedNum / value, precision)

			return `${formatted}${symbol}`
		}
	}

	return truncateNumber(processedNum, precision)
}
